import ContactForm from './components/ContactForm/ContactForm';
import {
  ContactFormJSON,
  contactFormValidationSchema,
} from './components/FormData/config';
import { SuccessMessage } from './components/ContactForm/SuccessMessage/SuccessMessage';
import './styles/styles.scss';

function App() {
  return (
    <div className="App">
      <ContactForm
        ContactFormJSON={ContactFormJSON}
        contactFormValidationSchema={contactFormValidationSchema}
        SuccessMessage={
          <SuccessMessage>
            {<p>Thank you! Your submission has been received!</p>}
          </SuccessMessage>
        }
      />
    </div>
  );
}

export default App;
